var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModificationBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 5.83333H6.41667L7.58333 4.66667H2.33333V5.83333ZM2.33333 3.5H5.83333V2.33333H2.33333V3.5ZM1.16667 1.16667V7H5.25L4.08333 8.16667H0V0H11.6667V1.75H10.5V1.16667H1.16667ZM12.1917 4.25833C12.2403 4.30694 12.2646 4.36042 12.2646 4.41875C12.2646 4.47708 12.2403 4.53056 12.1917 4.57917L11.6667 5.10417L10.6458 4.08333L11.1708 3.55833C11.2194 3.50972 11.2729 3.48542 11.3312 3.48542C11.3896 3.48542 11.4431 3.50972 11.4917 3.55833L12.1917 4.25833ZM6.41667 9.33333V8.3125L10.2958 4.43333L11.3167 5.45417L7.4375 9.33333H6.41667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModificationBookIcon);
export default __webpack_public_path__ + "static/media/ModificationBookIcon.49baa42d67fd1d084b32a2adb0852928.svg";
export { ForwardRef as ReactComponent };